module.exports = __webpack_public_path__ + "static/img/create-desktop.369755b6.png";